import React, { Component } from 'react';

export class OneDigit extends Component {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);

    }

    onClick()
    {
        if (typeof this.props.onClick === "function") {
            this.props.onClick(this.props.number);
        }
    }


    componentDidMount() {
    }


    render()
     {
         if(this.props.number=="")
         {
             this.number= " "+"__"+" " ;
         }
         else
         {
            this.number=traverse(this.props.number);
         }
         
         var fontsize="30px";
         var fontweight="normal";
         var width="80px";
         var padding="20px";
         var marginLeft="1px 1px 1px 1px";
         if(this.props.bold)
         {
             fontweight="bold";
             fontsize="50px";
             width="100px";
             padding="25px";
             marginLeft="3px 3px 3px 3px";

         }

         
         if(this.props.number=="")
         {
             fontweight="normal";
         }

         return (<input type="button" style={{fontSize:fontsize,fontWeight:fontweight ,paddingLeft:padding,paddingRight:padding,width:width , margin:marginLeft }} className="btn btn-outline-dark" value={this.number} onClick={this.onClick} />



        );
    }
}


    const persian = { 0: '۰', 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹' };
function traverse(el) {
    el=el.toString();
    var list = el.match(/[0-9]/g);
    if (list != null && list.length != 0) {
        for (var i = 0; i < list.length; i++)
            el = el.replace(list[i], persian[list[i]]);
    }
    return el;


}


// WEBPACK FOOTER //
// ./src/elements/OneDigit.js